import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Experience from "@/components/sections/Experience";
import Product from "@/components/sections/Product";
import Vision from "@/components/sections/Vision";
import Contact from "@/components/sections/Contact";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <About />
      <Experience />
      <Product />
      <Vision />
      <Contact />
    </main>
  );
}
